import styled from '@emotion/styled';
import { Alert, tokens } from '@hotjar/hotsauce';

const AlertContent = styled.div`
  display: inline-flex;
  margin-bottom: ${tokens.spacer.x2};
`;

export const ErrorAlert = ({ error }: { error: string | null }): JSX.Element | null => {
  return error === null ? null : (
    <div>
      <AlertContent role="alert">
        <Alert kind="danger">{error}</Alert>
      </AlertContent>
    </div>
  );
};
